import { AddCommonCreativeMethodExecutor } from './AddCreativeMethodExecutor/AddCommonCreativeMethodExecutor';
import { AddVideoCreativeMethodExecutor } from './AddCreativeMethodExecutor/AddVideoCreativeMethodExecutor';
import { AddOverlayMethodExecutor } from './AddOverlayMethodExecutor/AddOverlayMethodExecutor';
import { CommonCreativesApiMethodExecutor } from './CreativesApiMethodExecutor/CommonCreativesApiMethodExecutor';
import { VideoCreativesApiMethodExecutor } from './CreativesApiMethodExecutor/VideoCreativesApiMethodExecutor';
import { GalleryMethodExecutor } from './GalleryMethodExecutor/GalleryMethodExecutor';
import { Html5ApiMethodExecutor } from './Html5MethodExecutor/Html5ApiMethodExecutor';
import { IdeasMethodExecutor } from './IdeasMethodExecutor/IdeasMethodExecutor';
import { PresetsMethodExecutor } from './PresetsMethodExecutor/PresetsMethodExecutor';
import { PreviewMethodExecutor } from './PreviewMethodExecutor';

export class CanvasApi {
    readonly presets = new PresetsMethodExecutor();
    readonly ideas = new IdeasMethodExecutor();
    readonly commonCreatives = new CommonCreativesApiMethodExecutor();
    readonly videoCreatives = new VideoCreativesApiMethodExecutor();
    readonly addOverlayCreative = new AddOverlayMethodExecutor();
    readonly addVideoCreative = new AddVideoCreativeMethodExecutor();
    readonly addCommonCreative = new AddCommonCreativeMethodExecutor();
    readonly galleries = new GalleryMethodExecutor();
    readonly html5 = new Html5ApiMethodExecutor();
    readonly preview = new PreviewMethodExecutor();
}
